/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
/* eslint-disable require-jsdoc */
import {getMonth} from '../utils/date';
import {defaultImg} from '../utils/defaultImg';
import {formatDistance} from '../utils/distance';
import {isValid, getEventImage, checkImgURL} from '../utils/validate';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import TilePlayer from './TilePlayer';
import {TimeForCarouselTiles} from '../utils/TimeOrNoTime';

const Distance = (props) => {
  if (!isValid(props.distance) || props.eventType === 'livestream') {
    return null;
  }
  return (
    <strong className='hti-distance'>
      {formatDistance(props.distance)} mi
    </strong>
  );
};

const Tile = (props) => {
  // console.log('props = ', props);
  const event = props.results.event;
  const venue = props.results.venue;
  const bands = props.results.bands;

  const backUpImg = useMemo(() => {
    return defaultImg();
  }, [props.results]);


  // console.log('backUpImg', typeof backUpImg);
  const eventImg = getEventImage(props.eventImage);

  // console.log('eventTile.jsx eventImg', eventImg);
  // console.log('eventTile.jsx backUpImg', backUpImg);

  const handleEventGuidChange = () => {
    {isValid(event.eventGuid) ?
       props.onSlideChoiceChange(event.eventGuid) : null;}

    // console.log('eventTile.js eventGuid', event.eventGuid);
  };

  const onMouseUpArr=[];
  const onMouseDownArr=[];

  return (
    <div className='hearby-tile-event'
      onMouseUp={(e) => {
        e.preventDefault();
        const x2 = e.pageX;
        const y2 = e.pageY;
        onMouseUpArr.push(x2);
        onMouseUpArr.push(y2);
        // console.log('onMouseUpCoord', onMouseUpArr);
        onMouseDownArr && onMouseUpArr ?
        props.clickValidation(onMouseUpArr, onMouseDownArr) : null;
      }}

      onMouseDown={(e) => {
        e.preventDefault();
        const x1 = e.pageX;
        const y1 = e.pageY;
        onMouseDownArr.push(x1);
        onMouseDownArr.push(y1);
        // console.log('onMouseDownCoord', onMouseDownArr);
      }}

      onClick={(e) => {
        props.clicked();
        props.clicked()==='clicked' ? 
        handleEventGuidChange(): null
      }}

      style={{
        backgroundImage:
        `url(${eventImg}), url(${backUpImg})`,
      }}>

      <div className='hearby-tile-content'>
        {/* {console.log('eventTile.js eventGuid', event.eventGuid)} */}
        <a
          venue-name={venue.venueName}
          venue-lng={venue.lon}
          venue-lat={venue.lat}
          venue-id={venue.venueGuid}
          event-id={event.eventGuid}
          event-dist={venue.distance}
          default-img={isValid(eventImg) &&
            checkImgURL(eventImg) ? eventImg+' '+backUpImg : backUpImg}
          className='event-popup hearby-tile-cover hearby-event-popup'
        >
          <span className='hearby-tile-event-title'>{event.event}</span>
          <span className='hearby-tile-date'>
            <strong className='htd-month'>{getMonth(event.month)}</strong>
            <strong className='htd-day'>{event.day}</strong>
          </span>
          <span className='hearby-tile-venue-name'>{venue.venueName}</span>
          <span className='hearby-tile-info'>

            <TimeForCarouselTiles event={event}/>

            <Distance distance={venue.distance} eventType={props.eventType}/>
          </span>
        </a>
        <TilePlayer band={bands[0]} />
      </div>
    </div>
  );
};
Tile.propTypes = {
  results: PropTypes.shape({
    event: PropTypes.object.isRequired,
    venue: PropTypes.object.isRequired,
    bands: PropTypes.array.isRequired,
  }),
  clicked: PropTypes.func.isRequired,
  onSlideChoiceChange: PropTypes.func.isRequired,
  clickValidation: PropTypes.func.isRequired,

  eventImage: PropTypes.string,
};
Distance.propTypes = {
  distance: PropTypes.number.isRequired,
  eventType: PropTypes.string.isRequired,
};

export default Tile;
